




























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { RecurenceEnum, WeekdaysEnum, DatesOfMonth, MarkedDay, Time } from "@/services/posts/types";
import FunctionalCalendar from "vue-functional-calendar/src/components/FunctionalCalendar.vue";
import ScheduleValidation from "@/components/posts/PostScheduleValidation.vue";
import i18n from "@/i18n";
import { ActiveDaysRequest, PowerPlanEvent } from "@/services/powerPlans/types";
import { getActiveDays } from "@/services/powerPlans/powerPlanEventService";
import { calendarConfigs } from "@/services/functional-calendar";
import { powerPlanEventFromDate, powerPlanEventToDate, powerPlanEventTimeSpan } from "./powerPlanFormatting";

@Component({
    components: {
        "functional-calendar": FunctionalCalendar,
        "schedule-validation": ScheduleValidation
    }
})
export default class PowerPlanEventSchedule extends Vue {
    @Prop() private item!: PowerPlanEvent;
    recurenceEnum = RecurenceEnum;
    weekdaysEnum = WeekdaysEnum;
    datesOfMonth = DatesOfMonth;
    markedDates = [] as Array<MarkedDay>;
    defaultFromTime = "08:00";
    defaultToTime = "16:00";
    zeroTime = "00:00";
    time = Time
    showCalendar = true;
    isSelectDropdownVisible = false;

    // lifecycle hooks
    mounted() {
        const fromDate = !this.item.fromDate ? new Date() : new Date(this.item.fromDate);
        (this.$refs.calendarFromDate as any).clickDay({
            day: fromDate.getDate(),
            date: `${fromDate.getDate()}/${fromDate.getMonth() + 1}/${fromDate.getFullYear()}`,
            isMarked: true
        });
        if (this.item.toDate && !this.item.neverending) {
            const toDate = new Date(this.item.toDate);
            (this.$refs.calendarToDate as any).clickDay({
                day: toDate.getDate(),
                date: `${toDate.getDate()}/${toDate.getMonth() + 1}/${toDate.getFullYear()}`,
                isMarked: true
            });
        }
        if (this.item.recurenceType === this.recurenceEnum.yearly) {
            const date = new Date(this.item.yearly);
            (this.$refs.calendarYearly as any).clickDay({
                day: date.getDate(),
                date: `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`,
                isMarked: true
            });
        }
        if (this.item.allDay && !this.item.fromTime && !this.item.toTime) {
            this.item.fromTime = this.defaultFromTime;
            this.item.toTime = this.defaultToTime;
        }

        // Support nested dropdowns
        this.$root.$on("bv::dropdown::show", (bvEvent: any) => {
            if (bvEvent.target.parentElement.className.includes("select-dropdown")) {
                this.isSelectDropdownVisible = true;
            }
        });
        this.$root.$on("bv::dropdown::hide", (bvEvent: any) => {
            if (bvEvent.target.parentElement.className.includes("select-dropdown")) {
                this.isSelectDropdownVisible = false;
            }
            if (this.isSelectDropdownVisible) {
                bvEvent.preventDefault();
            }
        });
    }

    created() {
        this.loadActiveDays(this.firstDayOfThisMonth);
    }

    // methods
    recurenceTypeChanged() {
        this.item.recurenceValues = [];
    }

    changedMonth(startDate: Date) {
        this.loadActiveDays(startDate);
    }

    loadActiveDays(startDate: Date) {
        if (!this.item.id) return;
        getActiveDays({
            powerPlanId: this.item.id,
            calendarStartDate: startDate
        } as ActiveDaysRequest).then(response => {
            let i;
            for (i = 0; i < this.markedDates.length; i++) {
                Vue.set(this.markedDates, i, {});
            }
            response.forEach((date: string, i: number) => {
                Vue.set(this.markedDates, i, {
                    date: date,
                    class: "vfc-marked"
                });
            });
        });
    }

    getRecurenceDropdownLabel() {
        switch (this.item.recurenceType) {
        case this.recurenceEnum.daily:
            return i18n.t("posts.daily");
        case this.recurenceEnum.weekly:
            return this.getWeekDays(this.item.recurenceValues);
        case this.recurenceEnum.monthly:
            return this.item.recurenceValues.length > 0 ? this.item.recurenceValues.toString().split(",").join(", ") : i18n.t("posts." + this.recurenceEnum[this.recurenceEnum.monthly]);
        case this.recurenceEnum.yearly:
            return this.item.yearly ? i18n.d(new Date(this.item.yearly), "dayMonth") : i18n.t("posts." + this.recurenceEnum[this.recurenceEnum.yearly]);
        }
    }

    getWeekDays(values: number[]) {
        const result = values.map(x => {
            switch (x) {
            case WeekdaysEnum.monday:
                return i18n.t("posts.monday");
            case WeekdaysEnum.tuesday:
                return i18n.t("posts.tuesday");
            case WeekdaysEnum.wednesday:
                return i18n.t("posts.wednesday");
            case WeekdaysEnum.thursday:
                return i18n.t("posts.thursday");
            case WeekdaysEnum.friday:
                return i18n.t("posts.friday");
            case WeekdaysEnum.saturday:
                return i18n.t("posts.saturday");
            case WeekdaysEnum.sunday:
                return i18n.t("posts.sunday");
            }
            throw new Error("Not valid");
        });
        return result.toString().split(",").join(", ") || i18n.t("posts.weekly");
    }

    dayClicked() {
        if (this.item.neverending) this.item.neverending = false;
    }

    onNeverEndingChange(value: boolean) {
        if (!value) {
            this.item.toDate = this.item.fromDate;
        }
    }
    // computed

    get firstDayOfThisMonth(): Date {
        const today = new Date();
        const month = today.getMonth();
        const year = today.getFullYear();
        return new Date(year, month, 1);
    }

    get fromDate() {
        return {
            currentDate: new Date(),
            selectedDate: new Date(this.item.fromDate)
        };
    }

    set fromDate(date: any) {
        const dateParts = date.selectedDate.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.item.fromDate = dateObject.toDateString();
    }

    get toDate() {
        return {
            currentDate: new Date(),
            selectedDate: this.item.toDate
        };
    }

    get fromDateLabel() {
        return powerPlanEventFromDate(this.item);
    }

    get toDateLabel() {
        return powerPlanEventToDate(this.item);
    }

    get timeLabel() {
        return powerPlanEventTimeSpan(this.item);
    }

    set toDate(date: any) {
        const dateParts = date.selectedDate.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.item.toDate = dateObject.toDateString();
    }

    get fromTime() {
        return this.item.fromTime ? this.item.fromTime : "" as any;
    }

    set fromTime(time: any) {
        if (!time) {
            return;
        }

        if (time === this.zeroTime && this.toTime === this.zeroTime) {
            this.item.allDay = true;
            this.item.toTime = this.defaultToTime;
            this.item.fromTime = this.defaultFromTime;
            return;
        }
        this.item.fromTime = time;
        if (this.item.allDay) this.item.allDay = false;
    }

    get toTime() {
        return this.item.toTime ? this.item.toTime : "";
    }

    set toTime(time: any) {
        if (!time) {
            return;
        }
        if (time === this.zeroTime && this.fromTime === this.zeroTime) {
            this.item.allDay = true;
            this.item.toTime = this.defaultToTime;
            this.item.fromTime = this.defaultFromTime;
            return;
        }
        this.item.toTime = time;
        if (this.item.allDay) this.item.allDay = false;
    }

    get yearly() {
        return {
            currentDate: new Date(),
            selectedDate: this.item.fromDate
        };
    }

    set yearly(date: any) {
        const dateParts = date.selectedDate.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        const dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        this.item.yearly = dateObject.toDateString();
    }

    get calendarConfigs() {
        return calendarConfigs();
    }

    checkIfFormIsValid() {
        this.$emit("scheduleUpdated", (this.$refs.validation as any).isValid());
    }
}
